import { AccountingReportType, generateOptions } from '@constants';
import { memo, useState } from 'react';
import trans from 'translation';
import { KContainer, KGrid, KInput } from 'uikit';

import Invoice from './Invoice';
import Payment from './Payment';
import Statement from './Statement';

const ReportAccounting = () => {
  const [reportCode, setReportCode] = useState<string | undefined>('');

  return (
    <KContainer.Card marginT={'0.25rem'}>
      <KGrid.Container>
        <KGrid.Item xs={6}>
          <KInput.TextField
            name="report"
            label={trans('report')}
            value={reportCode}
            options={generateOptions(AccountingReportType)}
            onChange={e => setReportCode(e.target.value)}
          />
        </KGrid.Item>

        {!!reportCode && (
          <KGrid.Item xs={12}>
            <KContainer.RenderWhen>
              <KContainer.RenderWhen.If
                isTrue={reportCode === AccountingReportType.STATEMENT}
              >
                <Statement />
              </KContainer.RenderWhen.If>

              <KContainer.RenderWhen.If
                isTrue={reportCode === AccountingReportType.PAYMENT}
              >
                <Payment />
              </KContainer.RenderWhen.If>

              <KContainer.RenderWhen.If
                isTrue={reportCode === AccountingReportType.INVOICE}
              >
                <Invoice />
              </KContainer.RenderWhen.If>
            </KContainer.RenderWhen>
          </KGrid.Item>
        )}
      </KGrid.Container>
    </KContainer.Card>
  );
};

export default memo(ReportAccounting);
